"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const updateFlightNumber_1 = __importDefault(require("../../clients/booking/updateFlightNumber"));
const API_STATE_1 = __importDefault(require("../../constants/app/API_STATE"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Update Flight Number for Booking Domain Store
 * Right now this API does not return any response body on success
 * So no data observable
 */
class UpdateFlightNumberStore {
    constructor(initialState) {
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Makes update flight no for booking api call
         * @param errorHandler {function}
         */
        this.fetch = (0, mobx_1.flow)(function* (refId, flightNo, successHandler, errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.errorData = {};
                yield (0, updateFlightNumber_1.default)(refId, flightNo);
                // 200 http codes
                this.onSuccess(successHandler);
            }
            catch (err) {
                // all other http codes
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (successHandler) => {
            this.apiState = API_STATE_1.default.SUCCESS;
            if (successHandler) {
                successHandler();
            }
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
}
__decorate([
    mobx_1.observable
], UpdateFlightNumberStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], UpdateFlightNumberStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], UpdateFlightNumberStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], UpdateFlightNumberStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], UpdateFlightNumberStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.action.bound
], UpdateFlightNumberStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], UpdateFlightNumberStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], UpdateFlightNumberStore.prototype, "updateInitialState", void 0);
exports.default = UpdateFlightNumberStore;
